var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkphone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.40362C0 6.5227 7.47727 13.9987 11.5951 13.9987C12.0323 13.9987 12.8074 13.2152 13.0493 12.9116C14.4883 11.106 14.3136 10.9921 12.3893 9.71009C9.29659 7.64967 10.2324 8.90805 8.41836 9.39244C7.26643 8.62107 5.37763 6.73227 4.60626 5.58034C5.08412 3.79083 6.32575 4.66519 4.35229 1.70457C3.02893 -0.280689 2.94463 -0.531014 1.08713 0.949363C0.78353 1.19131 0 1.96642 0 2.40362Z",
    fill: "#C53EAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkphone);
export default __webpack_public_path__ + "static/media/pinkphone.676a4de2204bb75b7e38fe2d9bc4d3ac.svg";
export { ForwardRef as ReactComponent };